import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// The DynamicComponent rendered as a section header. Holds a destination
// DynamicComponent id, so the key is registered in BOTH dependency walkers
// (helpers/component-reference-keys.js and Models/Studio/DcDependencyWalker.php)
// -- without that the compiled closure omits the component and staging renders
// InvalidElement while the builder canvas paints it fine.
export default class FeedSeparatorsComponentId extends BaseOption {
  // Compile is the identity: a cached value unlike the raw one is stale (DynamicOption ignores it).
  static compiledIsRaw = true;

  static userInterfaceComponent = {
    label: "Separator component",
    component: inspectorTools.REFERENCED_COMPONENT_PICKER,
    descriptionMessage: "The component shown as each separator in this feed.",
    props: {
      candidateSource: "authored",
      showOpenButton: false,
    },
  };

  static defaultValue = 0;
}
